module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"requiredError":"this field can\u0027t be empty."},"de":{"requiredError":"Dieses Feld darf nicht leer sein."},"fr":{"requiredError":"Ce champ de peut pas être vide."},"it":{"requiredError":"Questo Feld darf nicht leer sein."}}')
  delete Component.options._Ctor
}
